"use strict";

var _topbar$clientHeight;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable no-unused-vars */
var elements = document.querySelectorAll("[data-observable]");
var callback = function callback(entry, data, isIntersecting) {
  switch (data) {
    case "fade-up":
      {
        if (!isIntersecting) break;
        entry.classList.add("visible");
        break;
      }
    case "fade-up-scroll-only":
      {
        if (!entry.classList.contains("fade-up-view")) {
          if (!isIntersecting) {
            entry.classList.add("fade-up-view");
          } else {
            entry.classList.add("opacity-100", "visible");
          }
        } else {
          entry.classList.add("visible");
        }
        break;
      }
    case "lazy-img":
      {
        if (!isIntersecting) break;
        entry.setAttribute("src", entry.getAttribute("data-src"));
        break;
      }
    case "fade-in-children":
      {
        var _parseInt;
        if (!isIntersecting) break;
        var delay = (_parseInt = parseInt(entry.getAttribute("delay"))) !== null && _parseInt !== void 0 ? _parseInt : 800;
        if (isNaN(delay) || typeof delay !== "number" || delay <= 0) {
          delay = 800;
        }
        Array.from(entry.children).forEach(function (child, i) {
          setTimeout(function () {
            child.classList.add("!opacity-100");
          }, delay * i + 300);
        });
        break;
      }
    case "count-up":
      {
        if (!isIntersecting) break;
        var countUp = function countUp(entry) {
          if (typeof animateCountUp !== "undefined") {
            // eslint-disable-next-line no-undef
            animateCountUp(entry);
            return;
          }
          setTimeout(function () {
            return countUp(entry);
          }, 1000);
        };
        countUp(entry);
        break;
      }
    case "map":
      {
        if (!isIntersecting) break;
        if (!entry.hasAttribute("src")) {
          if (entry.parentElement.classList.contains("allowed")) {
            loadMap(entry);
          }
        }
        break;
      }
    case "recaptcha":
      {
        if (!isIntersecting) break;
        loadReCaptcha();
        break;
      }
    case "facebook":
      {
        if (!isIntersecting) break;
        loadFacebookScript();
        break;
      }
    default:
      {
        console.error("Unknown data-observable: ".concat(data));
        break;
      }
  }
};
var observer = new IntersectionObserver(handleIntersection);
elements.forEach(function (obs) {
  observer.observe(obs);
});
function handleIntersection(entries) {
  entries.forEach(function (entry) {
    callback(entry.target, entry.target.getAttribute("data-observable"), entry.isIntersecting);
  });
}

// eslint-disable-next-line no-unused-vars
var onScrollEvents = [];
var lastKnownScrollPosition = 0;
var ticking = false;
document.addEventListener("scroll", function () {
  lastKnownScrollPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function () {
      // eslint-disable-next-line no-undef
      settings.onScroll.forEach(function (e) {
        return e(lastKnownScrollPosition);
      });
      ticking = false;
    });
    ticking = true;
  }
});
var navbar = document.querySelector("nav");
var topbar = document.querySelector(".top-bar");
var positionTrigger = (_topbar$clientHeight = topbar === null || topbar === void 0 ? void 0 : topbar.clientHeight) !== null && _topbar$clientHeight !== void 0 ? _topbar$clientHeight : 0;
// eslint-disable-next-line no-undef
settings.onScroll.push(function (lastKnownScrollPosition) {
  navbar.classList[lastKnownScrollPosition > positionTrigger ? "add" : "remove"]("scrolled");
});
var openModal = function openModal(modal) {
  var _document$querySelect;
  (_document$querySelect = document.querySelector("[modal=".concat(modal, "]"))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add("visible");
  loadReCaptcha();
};
document.querySelectorAll("[modal]").forEach(function (modal) {
  modal.addEventListener("click", function (e) {
    if (e.target.hasAttribute("modal")) {
      modal.classList.remove("visible");
    }
  });
});
function toggleMobileMenuJs(open) {
  document.body.classList[open ? "add" : "remove"]("menu-open");
}
document.querySelectorAll(".sub-menu").forEach(function (menu) {
  menu.setAttribute("height", menu.offsetHeight);
  menu.classList.add("max-h-0");
  if (menu.parentElement.classList.contains("open")) {
    menu.style.maxHeight = "".concat(menu.getAttribute("height"), "px");
  }
});
document.querySelectorAll("[menu]").forEach(function (chevron) {
  chevron.addEventListener("click", function () {
    var open = document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.contains("open");
    var submenu = document.querySelector(".sub-menu-".concat(chevron.getAttribute("menu")));
    if (open) {
      document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.remove("open");
      submenu.style.maxHeight = "0px";
    } else {
      document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.add("open");
      submenu.style.maxHeight = "".concat(submenu.getAttribute("height"), "px");
    }
  });
});
function handleRightFormSubmit() {
  var form = document.querySelector("#page-right-form");
  if (!form) {
    console.error("Couldn't find form #page-right-form");
    return;
  }
  var formButton = form.querySelector("button");
  if (formButton.classList.contains("loading")) {
    return;
  }
  formButton.classList.add("loading");
  var formData = new FormData(form);
  var formProps = Object.fromEntries(formData);
  var invalid = false;
  var inputsRequired = ["name", "phone", "message", "agree"];
  inputsRequired.forEach(function (input) {
    if (!formProps[input]) {
      console.log("error");
      form.querySelector("[name=".concat(input, "]")).setAttribute("error", "");
      invalid = true;
    }
    if (input == "email") {
      if (!/\S+@\S+\.\S+/.test(formProps[input])) {
        form.querySelector("[name=".concat(input, "]")).setAttribute("error", "");
        invalid = true;
      }
    }
  });
  if (invalid) {
    formButton.classList.remove("loading");
    return;
  }

  // eslint-disable-next-line no-undef
  fetch("".concat(settings.templateDir, "/post/call-offer.php"), {
    credentials: "same-origin",
    mode: "same-origin",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formProps)
  }).then(function (resp) {
    if (resp.status === 200) {
      return resp.json();
    } else {
      form.querySelector(".result-text").innerText = "Kunne ikke udføre anmodningen. Ring venligst direkte til os i stedet.";
      form.classList.add("text-red-600");
      return Promise.reject("server");
    }
  }).then(function () {
    formButton.classList.remove("loading");
    formButton.setAttribute("disabled", "");
    formButton.innerText = "Tak for din henvendelse!";
  }).catch(function (err) {
    if (err === "server") return;
    console.log(err);
  });
}
function handleSendEmailSubmit(token, formId) {
  var form = document.querySelector("#".concat(formId));
  var formButton = form.querySelector("button");
  if (formButton.classList.contains("loading")) {
    return;
  }
  formButton.classList.add("loading");
  var formData = new FormData(form);
  var formProps = Object.fromEntries(formData);
  var invalid = false;
  var inputsRequired = formId == "send-email" ? ["email", "message"] : ["name", "phone", "email", "message", "agree"];
  inputsRequired.forEach(function (input) {
    if (!formProps[input]) {
      console.log("error");
      form.querySelector("[name=".concat(input, "]")).setAttribute("error", "");
      invalid = true;
    }
    if (input == "email") {
      if (!/\S+@\S+\.\S+/.test(formProps[input])) {
        form.querySelector("[name=".concat(input, "]")).setAttribute("error", "");
        invalid = true;
      }
    }
  });
  if (invalid) {
    formButton.classList.remove("loading");
    return;
  }

  // eslint-disable-next-line no-undef
  fetch("".concat(settings.templateDir, "/post/send-email.php"), {
    credentials: "same-origin",
    mode: "same-origin",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formProps)
  }).then(function (resp) {
    if (resp.status === 200) {
      return resp.json();
    } else {
      form.querySelector(".result-text").innerText = "Kunne ikke udføre anmodningen. Ring venligst direkte til os i stedet.";
      form.classList.add("text-red-600");
      return Promise.reject("server");
    }
  }).then(function () {
    formButton.classList.remove("loading");
    formButton.setAttribute("disabled", "");
    formButton.innerText = "Tak for din henvendelse!";
  }).catch(function (err) {
    if (err === "server") return;
    console.log(err);
  });
}
var reCaptchaLoaded = false;
function loadReCaptcha() {
  if (reCaptchaLoaded) return;
  reCaptchaLoaded = true;
  var recaptchaScript = document.createElement("script");
  recaptchaScript.src = "https://www.google.com/recaptcha/api.js?hl=en";
  recaptchaScript.defer = true;
  document.body.appendChild(recaptchaScript);
}
var facebookScriptLoaded = false;
function loadFacebookScript() {
  if (facebookScriptLoaded) return;
  facebookScriptLoaded = true;
  var facebookScript = document.createElement("script");
  facebookScript.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0";
  facebookScript.defer = true;
  facebookScript.crossOrigin = "anonymous";
  document.body.appendChild(facebookScript);
}
var slideSelectors = document.querySelectorAll(".slide-selectors > div");
var selectSelector = function selectSelector(index) {
  slideSelectors.forEach(function (selector) {
    return selector.classList.remove("selected");
  });
  document.querySelector(".slide-selector-".concat(index + 1)).classList.add("selected");
};
var skipNextSlide = false;
var heroDelay = 3500;
var heroSlides = document.querySelectorAll(".hero-slide");
if (heroSlides.length > 1) {
  heroSlides.forEach(function (slide, i) {
    setTimeout(function () {
      slide.classList.remove("opacity-0");
      selectSelector(i);
      setInterval(function () {
        selectSelector(i);
        heroSlides.forEach(function (slide) {
          return slide.classList.add("opacity-0");
        });
        slide.classList.remove("opacity-0");
      }, heroSlides.length * heroDelay);
    }, i * heroDelay);
  });
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function deleteCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
var allowCookies = function allowCookies(allow) {
  setCookie("allowCookies", allow ? "true" : "false", 365);
  if (!allow) {
    deleteCookie("utm_content");
    deleteCookie("utm_campaign");
    deleteCookie("utm_source");
  }
  setCookieboxVisible(false);
  var map = document.querySelector(".map");
  if (map) {
    map.classList[allow ? "add" : "remove"]("allowed");
    if (allow) {
      if (isElementInViewport(map)) {
        loadMap(map.querySelector("iframe"));
      }
    }
  }
};
var setCookieboxVisible = function setCookieboxVisible(isVisible) {
  var cookiebox = document.querySelector("#cookiebox");
  cookiebox.classList[isVisible ? "remove" : "add"]("bottom-[-50rem]");
};
function onCustomRightFormInputFocus(e) {
  e.target.removeAttribute("error");
}
function onCustomRightFormSubmit(token) {
  handleCustomRightFormSubmit(token, "custom-right-form");
}
function handleCustomRightFormSubmit(token, formId) {
  var form = document.querySelector("#".concat(formId));
  var formButton = form.querySelector("button");
  if (formButton.classList.contains("loading")) {
    return;
  }
  formButton.classList.add("loading");
  var formData = new FormData(form);
  var formProps = Object.fromEntries(formData);
  var invalid = false;
  if (!("agree" in formProps)) {
    form.querySelector("[name=agree]").setAttribute("error", "");
    invalid = true;
  }
  for (var _i = 0, _Object$entries = Object.entries(formProps); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    var input = form.querySelector("[name=".concat(key, "]"));
    if (input.required && !value) {
      input.setAttribute("error", "");
      invalid = true;
    }
  }
  if (invalid) {
    formButton.classList.remove("loading");
    return;
  }

  // eslint-disable-next-line no-undef
  fetch("".concat(settings.templateDir, "/post/right-form.php"), {
    credentials: "same-origin",
    mode: "same-origin",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      parameters: formProps,
      "g-recaptcha-response": token
    })
  }).then(function (resp) {
    if (resp.status === 200) {
      return resp.json();
    } else {
      form.querySelector(".result-text").innerText = "Kunne ikke udføre anmodningen. Ring venligst direkte til os i stedet.";
      form.classList.add("text-red-600");
      return Promise.reject("server");
    }
  }).then(function (dataJson) {
    form.innerHTML = "\n    <div class=\"text-4xl font-extrabold\">Tak for din henvendelse!</div>\n    <div>Vi kontakter dig hurtigst muligt.</div>\n    ";
    form.classList.add("py-12");
  }).catch(function (err) {
    formButton.classList.remove("loading");
    if (err === "server") return;
    console.log(err);
  });
}
var scrollIntoViewById = function scrollIntoViewById(id) {
  var ids = id.split("||");
  var _iterator = _createForOfIteratorHelper(ids),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _id = _step.value;
      var element = document.querySelector("#".concat(_id));
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var loadMap = function loadMap(mapElement) {
  mapElement.src = !mapElement.getAttribute("x-src").startsWith("http") ? "https://google.com/" : mapElement.getAttribute("x-src");
};
var isElementInViewport = function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var mobileMenu = document.querySelector(".mobile-menu");
var links = mobileMenu.querySelectorAll("a");
links.forEach(function (link) {
  link.addEventListener("click", function (e) {
    if (e.target.classList.contains("fa-chevron-down")) {
      e.preventDefault();
      var parent = e.target.parentElement.parentElement;
      parent.classList.toggle("open");
    }
  });
});
//# sourceMappingURL=index.js.map